<template>
  <v-container>
    <v-card v-if="areacodePrompt" elevation="2" outlined tile>
      <v-card-title class="justify-center">Please enter your area code &hellip;</v-card-title>
      <v-card-text>
        <h3 style="text-align: center; margin: 0 0 2rem 0;">Then click GO! to link to our site that is closest to you.</h3>
        <div class="ma-auto" style="max-width: 300px">
          <v-otp-input
              v-model="otp"
              :length="otpLength"
          ></v-otp-input>
          <v-btn block :disabled="!isActive" @click="acComputeURL">GO!</v-btn>
        </div>
        <h5 style="text-align: center; margin: 2rem 0 2rem 0;">Welcome to {{ hostname }} (redirecting to: {{ url }})</h5>
      </v-card-text>
    </v-card>
    <v-card v-else elevation="2" outlined tile>
      <v-card-title class="justify-center">One moment...</v-card-title>
      <v-card-text>
        <h5 style="text-align: center; margin: 2rem 0 2rem 0;">Welcome to {{ hostname }} (redirecting to: {{ url }})</h5>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: 'VirtualMarketingPartners',
  data() {
    return {
      otp: '',
      otpLength: 3,
      areacodePrompt: false,
      hostname: window.location.hostname.replace(/^www\./, ''),
      url: '',
      redirects: [
        { 'hostname': '800newyear.com', 'url': 'http://www.1800newyears.com' },
        { 'hostname': '800newbraces.com', 'url': 'http://www.bracestoday.com' },
        { 'hostname': '800newwindow.com', 'url': 'http://www.cdwindows.com' },
        { 'hostname': '800newroof.com', 'url': 'http://www.donerightroofing.net' },
        { 'hostname': '800newlook.com', 'url': 'http://www.hailstormpros.com' },
        { 'hostname': '1800autodeal.com', 'url': 'http://www.ncautoauction.com' },
        { 'hostname': '800getwindows.com', 'url': 'http://www.taylorswindows.com' },
        { 'hostname': '800newteam.com', 'url': 'http://www.teamonetoyota.com' },
        { 'hostname': '800nextwindow.com', 'url': 'http://www.windowworldinc.com' },
        { 'hostname': '800newtubs.com', 'url': 'http://www.safesteptub.com' },
        { 'hostname': '800newbenz.com', 'url': 'http://www.chmb.com'},
      ],
    }
  },
  computed: {
    isActive () {
      return this.otp.length === this.otpLength
    },
  },
  methods: {
    redirect() {
      setTimeout(() => {
        console.info('redirecting to this.url', this.url)
        location.replace(this.url)
      }, 2000)
    },
    acComputeURL() {
      switch (this.otp) {
        default:
          this.url = 'https://www.800response.com'
      }
      this.redirect()
    }
  },
  mounted() {
    this.$nextTick( () => {
      this.url = "TBD"
      document.title = 'Welcome ' + this.hostname
      let redirectRecord = this.redirects.find( o => { return o.hostname.toLowerCase() == this.hostname }) || { 'hostname':'800response.com', 'url': 'https://www.800response.com' }
      this.url = redirectRecord.url
      console.info('redirectRecord', JSON.stringify(redirectRecord, null, 2))
      this.redirect()
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
